import {
  Box,
  LinearProgress,
  Stack,
  Typography,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import React from 'react';



export type UploadAttachmentCardProps = {
  handleClick: () => void;
  isLoading: boolean;
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: UploadAttachmentCardProps) => {
  const theme = useTheme();
  if (props.isLoading) {
    return (
      <LinearProgress />
    );
  }
  return (
    <Box
      padding='2.5rem'
      height='11.1875rem'
      display='flex'
      onClick={props.handleClick}
      flexDirection='row'
      justifyContent='center'
      alignItems='center'
      sx={{
        background: theme.palette.secondary.main,
        borderRadius: '1.5rem',
        border: `1px dashed ${theme.palette.primary.main}`
      }}
    >
      <Stack
        direction='column'
        rowGap='1rem'
        justifyContent='center'
      >
        <Box
          margin='auto'
          width='2.5rem'
          height='2.5rem'
          display='flex'
          border={`1px solid ${theme.palette.primary.main}`}
          borderRadius='.5rem'
          // padding='1rem'
          alignItems='center'
          justifyContent='center'
        >

          <CustomIcon.large.FC
            alignmentBaseline='central'
            sx={{
              justifyContent: 'center',
              border: `1px solid ${theme.palette.primary.main}`
            }}
            icon='UPLOAD'
            stroke={theme.palette.primary.main}
          />

        </Box>
        <Box
          component='span'
        >
          <Typography
            textAlign='center'
            color={theme.palette.primary.main}
          >
            Click to upload a file
          </Typography>
          <Typography
            textAlign='center'
          >or drag and drop
          </Typography>
        </Box>
      </Stack>
    </Box>
  );
};
